import { styled } from "@mui/material/styles";
import { InputBase } from "@mui/material";

export const SearchContainer = styled("div")`
  text-align: center;
  margin-bottom: 20px;
`;

export const SearchInput = styled(InputBase)`
  width: 300px;
  font-size: 16px;
  padding: 5px 10px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
`;
